import React from 'react';
import { Box } from '@mui/material';

/**
 * Renders a Lasertag group name (e.g. "lustige Waschbären") with the first letter of each word emphasized.
 */
function GroupNameDisplay({ name, component = 'span', ...rest }) {
  if (!name || typeof name !== 'string') return null;

  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return null;

  const Component = component;

  return (
    <Component {...rest}>
      {words.map((word, i) => (
        <React.Fragment key={i}>
          <Box
            component='span'
            fontWeight='bold'
            fontSize='1.1em'
            sx={{ textTransform: 'capitalize' }}
          >
            {word[0]}
          </Box>
          {word.slice(1)}
          {i < words.length - 1 ? ' ' : ''}
        </React.Fragment>
      ))}
    </Component>
  );
}

export default GroupNameDisplay;
